import { useIntl } from 'react-intl'
import ExperienceSearchPageFilters from './ExperienceSearchPageFilters'
import TextButton from 'LuxKit/Button/TextButton'
import FilterPanelFilterGroup from 'components/Common/FilterPanel/FilterPanelFilterGroup'
import ExperiencesSortByOptions from './ExperiencesSortByOptions'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'

interface Props {
  open?: boolean
  onClose?: () => void
  place?: App.Place
}

function ExperienceSearchPageFiltersSidebar(props: Props) {
  const {
    open,
    onClose,
    place,
  } = props
  const intl = useIntl()

  return (
    <ModalBase
      mode="drawer"
      isOpen={open}
      onClose={onClose}
    >
      <ModalHeader
        title={intl.formatMessage({
          id: '-sHD19_YfrtV2KBci1xt',
          defaultMessage: 'Sort & filter',
          description: 'Title for the sort and filter sidebar modal in experience search',
        })}
        onCloseButtonClick={onClose}
      />
      <ModalBody>
        <ModalContent>
          <FilterPanelFilterGroup
            title={intl.formatMessage({
              id: 'iD2zuFMw3T1Y-PseOsOg',
              defaultMessage: 'Sort by',
              description: 'Title for the sort options group in experience search filter sidebar',
            })}
          >
            <ExperiencesSortByOptions />
          </FilterPanelFilterGroup>
          <ExperienceSearchPageFilters
            place={place}
          />
        </ModalContent>
      </ModalBody>
      <ModalFooter>
        <TextButton kind="primary" onClick={onClose} fit="full-width">
          {intl.formatMessage({
            id: 'XGAxBfjicX0x40wpm7Xt',
            defaultMessage: 'Apply',
            description: 'Button text to apply sort and filter selections in experience search',
          })}
        </TextButton>
      </ModalFooter>
    </ModalBase>
  )
}

export default ExperienceSearchPageFiltersSidebar
